import { EventEmitter } from "../util/eventemitter";

global.MSG_TYPE = {
    SAY: 0,
    SHOUT: 1,
    WHISPER: 2,
    PARTY: 3,
    TRADE: 4,
    CLAN: 5,
    ALLY: 6,
    SYSTEM: 7,
    NOTICE: 8,
    ERROR: 9,
    QUEST: 10,
    QUEST_REWARD: 11,
};

export class ChatManagerMessageType {
    name: any;
    prefix: any;
    sendFunc: any;

    constructor(name: any, prefix: any, sendFunc: any) {
        this.name = name;
        this.prefix = prefix;
        this.sendFunc = sendFunc;
    }
}

export class ChatManagerMessage {
    type: any;
    message: any;
    sender: any;

    constructor(type: any, message: any, sender: any, senderObject: any) {
        this.type = type;
        this.message = message;

        if (sender || senderObject) {
            this.sender = {
                name: sender,
                object: senderObject,
            };
        }
    }
}

class _ChatManager extends EventEmitter {
    types: any[];

    static MessageType = ChatManagerMessageType;
    static Message = ChatManagerMessage;

    constructor() {
        super();

        this.types = [
            new _ChatManager.MessageType("say", null, this.say.bind(this)),
            new _ChatManager.MessageType("shout", "!", this.shout.bind(this)),
            new _ChatManager.MessageType("whisper", '"', this.whisper.bind(this)),
            new _ChatManager.MessageType("party", "#", this.clan.bind(this)),
            new _ChatManager.MessageType("trade", "$", this.trade.bind(this)),
            new _ChatManager.MessageType("clan", "@", this.clan.bind(this)),
            new _ChatManager.MessageType("ally", "~", this.clan.bind(this)),
            new _ChatManager.MessageType("system", null, this.system.bind(this)),
            new _ChatManager.MessageType("notice", null, this.notice.bind(this)),
            new _ChatManager.MessageType("error", null, this.error.bind(this)),
            new _ChatManager.MessageType("quest", null, this.quest.bind(this)),
            new _ChatManager.MessageType(
                "quest-reward",
                null,
                this.questReward.bind(this)
            ),
        ];
    }

say(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatSay(message);
        return true;
    }

    shout(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatShout(message);
        return true;
    }

    whisper(message: any) {
        const match = message.match(/([^ ]*) (.*)/);
        if (!match) {
            return false;
        }

        this.addGameMessage(MSG_TYPE.WHISPER, match[2], "To " + match[1], null);
        netGame.chatWhisper(match[1], match[2]);
        return true;
    }

    party(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatParty(message);
        return true;
    }

    trade(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatTrade(message);
        return true;
    }

    clan(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatClan(message);
        return true;
    }

    ally(message: any) {
        if (!message) {
            return false;
        }

        netGame.chatAlly(message);
        return true;
    }

    system(message: any) {
        this.addSystemMessage(MSG_TYPE.SYSTEM, message);
        return true;
    }

    notice(message: any) {
        this.addSystemMessage(MSG_TYPE.NOTICE, message);
        return true;
    }

    error(message: any) {
        this.addSystemMessage(MSG_TYPE.ERROR, message);
        return true;
    }

    quest(message: any) {
        this.addSystemMessage(MSG_TYPE.QUEST, message);
        return true;
    }

    questReward(message: any) {
        this.addSystemMessage(MSG_TYPE.QUEST_REWARD, message);
        return true;
    }

    addGameMessage(
        type: any,
        message: any,
        sender: any,
        senderObject: any
    ) {
        let msg = new _ChatManager.Message(type, message, sender, senderObject);
        this.emit("game_message", msg);
    }

    addSystemMessage(type: any, message: any) {
        const msg = new _ChatManager.Message(type, message, null, null);
        this.emit("system_message", msg);
    }
}

export const GCM = new _ChatManager();
